<template>
  <div id="dc-user-manager">
    <section>
      <div class="upper">
        <button class="main_btn" @click="onClickUserInvitation">新規ユーザーの招待</button>
      </div>
      <table class="user_manage_tbl">
        <tbody>
          <tr>
            <th>管理番号</th>
            <th>タイプ</th>
            <th>氏名</th>
            <th>ID/メールアドレス</th>
            <th>最終ログイン日</th>
            <th></th>
            <th></th>
          </tr>
          <tr v-for="(user, index) in userList" :key="'userlist_' + index">
            <td>{{ user.userId }}</td>
            <td>{{ userType(user.userType) }}</td>
            <td>{{ user.userLastName }} {{user.userFirstName}}</td>
            <td>{{ user.email }}</td>
            <td>{{ lastLogin(user.userId) }}</td>
            <td>
              <div :class="{detail_btn6: true, disabled: isAdminLoginUser(user.userId)}" @click="onEdit(user)">編集</div>
            </td>
            <td>
              <div :class="{detail_btn6: true, disabled: isAdminLoginUser(user.userId)}" @click="onDel(user)">削除</div>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import {mapActions, mapState} from 'vuex'
import store from '../../../store/index'
import * as App from '../../../utils/App'
import * as Api from '../../../utils/Api'
import * as AppEc from '../../utils/AppEc'
import {USER_TYPE} from '../../constants/TypeEc'
import {DC_URL, DC_STORAGE_KEY} from '../../../constants/App'

export default {
  name: 'UserManageModal',
  store: store,
  components: {
  },
  data () {
    return {
      /** モーダル判定 */
      modalShown: false,
      userInfo: {}
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        document.addEventListener('keydown', this.onKeydown)
      } else {
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  computed: {
    // ユーザー一覧
    ...mapState({
      userList: state => state.userList
    })
  },
  methods: {
    ...mapActions({ getUserList: 'loadUserListDc' }),
    /** モーダル表示 */
    showModal: function () {
      this.modalShown = true
    },
    onEdit: function (userObj) {
      let modalData = {
        userObj: userObj
      }
      AppEc.showUserModal(modalData)
    },
    onDel: function (userObj) {
      let modalData = {
        messages: ['本当に削除しますか？'],
        modalType: 'confirm',
        textAlign: 'center',
        onOk: () => {
          let payload = {
            userId: userObj.userId,
            userType: userObj.userType
          }
          axios.post(DC_URL.USER + '/delete-user', payload
          ).then(response => {
            this.$store.dispatch('loadUserListDc')
            let modalData = {
              messages: ['削除しました。'],
              textAlign: 'center'
            }
            App.showModal(modalData)
          }).catch(error => {
            Api.handleError(error, this.errorMessage, this.validateErrorMessages)
            this.$router.push('/error')
          })
        }
      }
      App.showModal(modalData)
    },
    /** 最終ログイン日時 */
    lastLogin: function (id) {
      if (this.userList && this.userList.length > 0) {
        // idで該当するユーザーを検索
        let userObj = this.userList.find(obj => { if (obj.userId === id) return obj })
        if (userObj.userLastlogindt === null) {
          return ''
        } else {
          return moment(userObj.userLastlogindt).format('YYYY/MM/DD HH:mm:ss')
        }
      }
    },
    onClickUserInvitation: function () {
      AppEc.showInviteUserModal()
    },
    isAdminLoginUser: function (userId) {
      // 自分の権限が管理者のみ変更/削除可能
      if (this.userInfo.userType !== 'DC_ADMIN') {
        return true
      }
      // 自身のユーザは変更/削除させない
      if (userId === this.loginUserId) {
        return true
      }
      return false
    },
    userType: function (val) {
      let type = Object.keys(USER_TYPE)
        .map(e => USER_TYPE[e])
        .find(e => e.code === val)
      if (!type) return ''
      return type.label
    }
  },
  mounted: function () {
    this.$store.dispatch('loadUserListDc', {reload: true})
  },
  created: function () {
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    this.loginUserId = this.userInfo.userId
  }
}
</script>
<style src="../../css/dc-order.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.upper{
  margin-bottom: 30px;
  text-align: left;
}
.data-area {
  margin: 40px auto;
}
.title-area {
  display:flex;
}
.um-modal {
  max-height: 100%;
  max-width: 1500px;
  padding-left: 40px;
  padding-right: 40px;
}
table{
  text-align: center;
}
h2{
  margin: auto;
  padding-right: 29px;
}
.hid_th{
  background:none;
  border: none;
}
.sm {
  width: 35px;
}
.md{
  width: 127px
}
.hid_td{
  border:none;
}
</style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/user/DcAccountManager.vue